<script setup>
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import AppMenuItem from './AppMenuItem.vue';

const store = useStore();
const user = computed(() => store.state.user); // ✅ Vuex에서 user 가져오기
const enterprise_seq = computed(() => store.state.user?.enterprise_seq || '');
const encoderSeq = computed(() => store.state.user?.encoderSeq || '');

// 메뉴 데이터
const menus = ref([
  {
    label: '대시보드',
    icon: 'pi-th-large',
    to: '/new/dashboard',
  },
  {
    label: '실시간모니터링',
    icon: 'pi-video',
    children: [
      {
        label: 'Site 별 전체 카메라',
        to: computed(() => {
          return '/new/cameraMonitoring/CameraAllDepthList/partner/' + (encoderSeq.value || null);
        }),
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['lksam']  // ✅ 기업 권한
      },
      {
        label: 'Site 별 카메라',
        to: computed(() => {
          return '/new/cameraMonitoring/CameraDepthList/partner/' + (encoderSeq.value || null);
        }),
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['lksam']  // ✅ 기업 권한
      },
      {
        label: 'Site 별 전체 카메라',
        to: computed(() => {
          return '/new/cameraMonitoring/CameraAllDepthList/client/' + (encoderSeq.value || null);
        }),
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['partner']  // ✅ 기업 권한
      },
      {
        label: 'Site 별 카메라',
        to: computed(() => {
          return '/new/cameraMonitoring/CameraDepthList/client/' + (encoderSeq.value || null);
        }),
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['partner']  // ✅ 기업 권한
      },
      {
        label: '전체 카메라',
        to: computed(() => {
          return '/new/cameraMonitoring/all/' + (encoderSeq.value || null);
        }),
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['client']  // ✅ 기업 권한
      },
      {
        label: 'Site 별 카메라',
        to: computed(() => {
          return '/new/cameraMonitoring/CameraDepthList/site/' + (encoderSeq.value || null);
        }),
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['client']  // ✅ 기업 권한
      },
      {
        label: '전체 카메라',
        to: computed(() => {
          return '/new/cameraMonitoring/all/' + (encoderSeq.value || null);
        }),
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['site']  // ✅ 기업 권한
      },
      {
        label: '카메라 별',
        to: computed(() => {
          return '/new/cameraMonitoring/list-new/' + (encoderSeq.value || null);
        }),
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['site']  // ✅ 기업 권한
      }
    ],
  },
  {
    label: '경고 목록',
    icon: 'pi-exclamation-triangle',
    to: '/new/alert/list',
  },
  {
    label: '통계',
    icon: 'pi-chart-bar',
    to: '',
    children: [
      {
        label: '월간 리포트',
        to: computed(() => {
          return '/new/statistics/month/' + (encoderSeq.value || null);
        }),
      },
      {
        label: 'Site별 리포트',
        to: '/new/statistics/enterpriseList',
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['client']  // ✅ 기업 권한
      },
      {
        label: '기간별 리포트',
        to: '/new/statistics/reportPeriod',
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['lksam','client', 'site']  // ✅ 기업 권한
      },
      /*{
        label: '통계 다운로드',
        to: '',
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['lksam'],  // ✅ 기업 권한
      }*/
    ]
  },
  {
    label: '기업 관리',
    icon: 'pi-building',
    to: '',
    requiresRole: ['admin', 'user'],  // ✅ 유저 권한
    requiresEnterpriseRole: ['lksam'],  // ✅ 기업 권한
    children: [
      {
        label: '기업 관리',
        to: '/new/enterprise',
      },
      {
        label: 'SMS 관리',
        to: '/new/sms/enterprise',
      }
    ],
  },
  {
    label: 'Site 관리',
    icon: 'pi-building',
    to: '',
    requiresRole: ['admin', 'user'],  // ✅ 유저 권한
    requiresEnterpriseRole: ['client'],  // ✅ 기업 권한
    children: [
      {
        label: 'SMS 관리',
        to: '/new/sms/enterprise',
      }
    ],
  },
  {
    label: '회원 관리',
    icon: 'pi-users',
    to: '/new/user',
    requiresRole: ['admin'],  // ✅ 유저 권한
  },
  {
    label: '녹화 영상 다운로드',
    icon: 'pi-play-circle',
    to: '/new/videoDownload/VideoDownloadEnterpriseList',
    requiresRole: ['admin'],  // ✅ 유저 권한
    requiresEnterpriseRole: ['lksam','client'],  // ✅ 기업 권한
  },
  {
    label: 'SMS 관리',
    icon: 'pi-envelope',
    to: computed(() => {
      return '/new/sms/' + (encoderSeq.value || null);
    }),
  },
  {
    label: '정보 관리',
    icon: 'pi-book',
    to: '',
    requiresRole: ['admin', 'user'],  // ✅ 유저 권한
    requiresEnterpriseRole: ['lksam'],  // ✅ 기업 권한
    children: [
      {
        label: '서버 시리얼키 관리',
        to: '/new/information/serialKey/list',
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['lksam'],  // ✅ 기업 권한
      },
      {
        label: 'MQTT 인증서 관리',
        to: '/new/information/mqtt/cert/list',
        requiresRole: ['admin', 'user'],
        requiresEnterpriseRole: ['lksam'],
      },
    ],
  },
  {
    label: 'SYMON-FDS',
    icon: 'icon-symon',
    to: '',
    children: [
      {
        label: '프로그램 관리',
        to: '/new/symon-fds/program/manage',
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['lksam'],  // ✅ 기업 권한
      },
      {
        label: '프로그램 다운로드',
        to: '/new/symon-fds/download',
        // noAccessRoles: ['syopt'],
      },
      {
        label: '매뉴얼 관리',
        to: '/new/symon-fds/manual/manage',
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['lksam'],  // ✅ 기업 권한
      },
      {
        label: '매뉴얼',
        to: '/new/symon-fds/manual',
        exact: true,
      },
    ],
  },
  {
    label: '고객센터',
    icon: 'pi-comments',
    to: '',
    requiresRole: ['admin', 'user'],  // ✅ 유저 권한
    requiresEnterpriseRole: [''],  // ✅ 기업 권한
    children: [
      {
        label: '공지사항',
        to: '/new/customer/notice',
      },
      {
        label: '자주 묻는 질문',
        to: '/new/customer/faq',
      },
      {
        label: '서비스 요청',
        to: '/new/customer/service-request',
      },
      {
        label: '견적 요청',
        to: '',
      },
      {
        label: '구독 및 신청',
        to: '',
      },
      {
        label: '지난 녹화 영상 요청',
        to: '',
      },
      {
        label: '자료실',
        to: '/new/customer/resource',
      },
    ],
  },
  {
    label: '로그',
    icon: 'pi-align-left',
    to: '',
    requiresRole: ['admin', 'user'],  // ✅ 유저 권한
    requiresEnterpriseRole: ['lksam'],  // ✅ 기업 권한
    children: [
      {
        label: '프로그램 사용 로그',
        to: '/new/log/programUseLog/list',
        requiresRole: ['admin', 'user'],  // ✅ 유저 권한
        requiresEnterpriseRole: ['lksam'],  // ✅ 기업 권한
      },
      /*{
        label: '로그인 내역',
        to: '',
      },
      {
        label: '기업별 카메라 및 오류 내역',
        to: '',
      },
      {
        label: '녹화 영상 다운로드 내역',
        to: '',
      },
      {
        label: 'SMS 발송 내역',
        to: '',
      },*/
    ],
  },
  {
    label: '나의 페이지',
    icon: 'pi-user',
    to: '/new/my-page',
  },
  /*{
    label: '페이지 템플릿',
    icon: 'pi-file',
    children: [
      {
        label: '기본 템플릿 목록형',
        to: '/new/template-ex',
      },
      {
        label: '필터 템플릿 목록형',
        to: '/new/template-filter',
      },
      {
        label: '템플릿 쓰기형',
        to: '/new/template/write',
      },
      {
        label: '템플릿 상세형',
        to: '/new/template/detail',
      }
    ],
  },
  {
    label: 'UI Template',
    icon: 'pi-palette',
    children: [
      {
        label: 'Grid',
        to: '/new/ui-template/grid',
      },
      {
        label: 'Button',
        to: '/new/ui-template/button',
      },
      {
        label: 'Misc',
        to: '/new/ui-template/misc',
      },
      {
        label: 'Input',
        to: '/new/ui-template/input',
      },
      {
        label: 'Form',
        to: '/new/ui-template/form',
      },
      {
        label: 'Toast',
        to: '/new/ui-template/toast',
      },
      {
        label: 'Dialog',
        to: '/new/ui-template/dialog',
      },
      {
        label: 'Table',
        to: '/new/ui-template/table',
      },
      {
        label: 'Paginator',
        to: '/new/ui-template/paginator',
      },
    ],
  },*/
]);

// 사용자가 특정 메뉴를 볼 수 있는지 확인하는 함수
const canViewMenuItem = (item) => {
  const userRole = user.value?.user_role;  // ✅ Vuex에서 가져온 user 값 사용
  const enterpriseRole = user.value?.enterprise_role; // ✅ Vuex에서 가져온 기업 권한 사용

  // 1️⃣ 유저 권한 체크
  const hasUserRole = !item.requiresRole || item.requiresRole.includes(userRole);

  // 2️⃣ 기업 권한 체크
  const hasEnterpriseRole = !item.requiresEnterpriseRole || item.requiresEnterpriseRole.includes(enterpriseRole);

  // 3️⃣ 두 개의 조건이 모두 만족해야 true 반환
  return hasUserRole && hasEnterpriseRole;
};


// `noAccessRoles`을 반영하여 메뉴 필터링
const filterMenus = (menus) => {
  return menus
      .filter(menu => canViewMenuItem(menu))  // ✅ Vuex에서 가져온 `user` 데이터 기반 필터링
      .map(menu => {
        if (menu.children) {
          const filteredChildren = filterMenus(menu.children);
          if (filteredChildren.length > 0) {
            return { ...menu, children: filteredChildren };
          }
        }
        return menu;
      });
};

// 필터링된 메뉴
const accessbleMenus = computed(() => filterMenus(menus.value));

</script>

<template>
  <ul class="app-nav">
    <template v-for="(item, i) in accessbleMenus" :key="i">
      <app-menu-item :item="item"></app-menu-item>
    </template>
  </ul>
</template>

<style lang="scss" scoped></style>
